<template>
    <main v-if="!auth">
        <AppIpadBackground />
        <AppSiteHeader />
        <div class="container">
            <div class="page">
                  <AppHome v-if="home"/>
                  <AppRegister v-if="!home"/>
            </div>
        </div>
        <AppSiteFooter />
    </main>
</template>
<script>
import axios from 'axios';
import AppHome from '@/components/AppHome'
import AppRegister from '@/components/AppRegister'
import AppIpadBackground from '@/components/AppIpadBackground'
import AppSiteHeader from '@/components/AppSiteHeader'
import AppSiteFooter from '@/components/AppSiteFooter'
import appStyles from '@/styles/appStyles.scss'
import { SpringSpinner } from 'epic-spinners'

export default {
    name: 'register',
    components: {
        appStyles,
        AppHome,
        AppRegister,
        AppSiteHeader,
        AppSiteFooter,
        AppIpadBackground
    },
    data() {
        return {
            home: '',
            auth: false,
        }
    },
    methods: {
        setBG: function(height) {
            document.querySelector('main .background').style.height = height;
            console.log(height);
        },
        removeOverflow: function() {
            var el = document.querySelector('main');
            el.style.overflow = 'hidden';
        }
    },
    mounted() {
    },
    beforeMount(){
      // console.log(this.$session.getAll());
      // console.log(this.$route);
      this.$route.name === 'home' ? this.home = true: null;
      this.$route.name === 'register' ? this.home = false: null;
      this.$session.get('logged_in') && this.$route.name === 'register' ? this.auth = true : '';
      this.$session.get('logged_in') && this.$route.name === 'register' ? this.$router.push({ path: `/instructions` }) : '';
    },
    watch: {
      $route(to, from) {
        // console.log(to);
        // console.log(from);
        to.name === 'register' ? this.home = false : null;
        to.name === 'home' ? this.home = true : null;
        this.$session.get('logged_in') && to.name === 'register' ? this.auth = true : '';
        this.$session.get('logged_in') && to.name === 'register' ? this.$router.push({ path: `/instructions` }) : '';
      }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
/* #app {
    display: grid;
} */
h1 {
    margin-top: 0;
    margin-bottom: 1.5em;
}

.field {
    margin: 10px 0 0 0;
    display: flex;
    flex-direction: column;
    align-items: center;
}

input {
    margin: 14px 0;
    height: 30px;
    border: 0px solid;
    border-radius: 30px;
    font-size: 14px;
    text-align: center;
    background-color: #f3f3f3;
}


.chekbox_field {
    display: block;
    position: relative;
    padding-left: 35px;
    margin: 20px 0;
    cursor: pointer;
    text-align: center;
    font-size: 1em;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

/* Hide the browser's default checkbox */
.chekbox_field input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

/* Create a custom checkbox */
.checkmark {
    position: absolute;
    top: 0;
    left: calc(20% - 20px);
    height: 20px;
    width: 20px;
    background-color: #eee;
}

/* On mouse-over, add a grey background color */
.chekbox_field:hover input~.checkmark {
    background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.chekbox_field input:checked~.checkmark {
    background-color: #73a3fc;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the checkmark when checked */
.chekbox_field input:checked~.checkmark:after {
    display: block;
}

/* Style the checkmark/indicator */
.chekbox_field .checkmark:after {
    left: 7px;
    top: 2.5px;
    width: 2.5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}

input {
    max-width: 400px;
    width: 100%;
}

/* @media (max-width: 1024px) {
    .bg_item {
        zoom: 0.6;
    }
    .bg_ipad {
        zoom: 0.7;
        width: 200px;
    }
} */
</style>